import React, {Fragment} from 'react';
import cx from 'classnames';
import { Link } from "react-router-dom";
import {connect} from 'react-redux';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import HeaderLogo from '../AppLogo';
import UserBox from './Components/UserBox';
import logo from '../../../src/assets/utils/images/brand-logo.png';
import SyncFailed from './Components/SyncFailed';
import { isValidRole } from '../../utils/utils';

class Header extends React.Component {
    render() {
        let {
            headerBackgroundColor,
            enableMobileMenuSmall,
            hideHamberger
            // enableHeaderShadow
        } = this.props;
        return (
            <Fragment>
                <ReactCSSTransitionGroup
                    component="div"
                    className={cx("app-header", headerBackgroundColor,)}
                    transitionName="HeaderAnimation"
                    transitionAppear={true}
                    transitionAppearTimeout={1500}
                    transitionEnter={false}
                    transitionLeave={false}>

                   
                    
                
                    <div className={cx(
                        "app-header__content",
                        {'header-mobile-open': enableMobileMenuSmall},
                    )}>
                          {!hideHamberger && <HeaderLogo/>}
                          <div className={`logo-src ${!hideHamberger?"":"ml-4"}`}>
                          <Link to="/">
                            <img className="main-logo" src={logo} alt="Logo" />    
                            </Link>
                            </div>
                        <div className="app-header-right"> 
                            {isValidRole('MENU_ENTITLEMENT_MISMATCH') && <SyncFailed/>}                   
                            <UserBox/>
                        </div>
                    </div>
                </ReactCSSTransitionGroup>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    // enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
    closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
    headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
    enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Header);